import { errorThatWillCauseAlertAndThrow } from 'owa-trace';

import type { CreateAccountResult, RemoveAccountResult } from './types';

/**
 * Defines the interface that the hosting application must implement
 */
export interface PluggableHostAccountSource {
    preSelectAccount?: (sourceId: string) => Promise<void>;
    addM365Account?: (email: string) => Promise<CreateAccountResult>;
    addOutlookDotComAccount?: (email: string) => Promise<CreateAccountResult>;
    removeAccount?: (sourceId: string) => Promise<RemoveAccountResult>;
}

// The pluggable host instance
let thePluggableHost: PluggableHostAccountSource = {};

/**
 * Sets the pluggable host
 * @param host provides the host specific implementation for getting account information
 */
export function updatePluggableHost(host?: Partial<PluggableHostAccountSource>) {
    thePluggableHost = { ...thePluggableHost, ...host };
}

/**
 * Restores the pluggable host to the default pluggable host
 */
export function testHookToResetPluggableHost() {
    thePluggableHost = {};
}

export async function preSelectAccount(sourceId: string): Promise<void> {
    if (thePluggableHost.preSelectAccount) {
        return thePluggableHost.preSelectAccount(sourceId);
    }
}

export async function addM365Account(email: string): Promise<CreateAccountResult> {
    if (!thePluggableHost.addM365Account) {
        errorThatWillCauseAlertAndThrow('NoPluggableMethodAddM365Account');
    }

    return thePluggableHost.addM365Account!(email);
}

export async function addOutlookDotComAccount(email: string): Promise<CreateAccountResult> {
    if (!thePluggableHost.addOutlookDotComAccount) {
        errorThatWillCauseAlertAndThrow('NoPluggableMethodAddOutlookDotComAccount');
    }

    return thePluggableHost.addOutlookDotComAccount!(email);
}

export async function removeAccount(sourceId: string): Promise<RemoveAccountResult> {
    if (!thePluggableHost.removeAccount) {
        errorThatWillCauseAlertAndThrow('NoPluggableMethodRemoveAccount');
    }

    return thePluggableHost.removeAccount!(sourceId);
}
